<div class="container android">
  <div class="row">
    <div class="col-12 mt-3">
      <span style="font-size: 30px" (click)="dismiss()">&times;</span>
    </div>
    <div class="col-12">
      <img class="android-intro-logo" src="https://app.mypomodoro.ir/logo.8e759e2100b07ca5d39e.svg" alt="">
    </div>
    <div class="col-12 mb-3 mt-4">
      <div class="cent-intro">
        وب اپلیکیشن پومودورو را به صفحه اصلی موبایل خود اضافه کنید.
      </div>
    </div>
    <hr class="my-2">
    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <div class="android-pwa-intro-info first-pwa-info">
            1- در نوار پایین یا بالا روی 	<div class="icon-section"><mat-icon>more_vert</mat-icon></div> بزنید.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="android-pwa-intro-info second-pwa-info">
            2- در منوی باز شده، گزینه Add To Homescreen یا افزودن به صفحه اصلی را انتخاب کنید.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="android-pwa-intro-info">
            3- در پنجره باز شده، دکمه Add را انتخاب کنید.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <button class="btn btn-block android_notice_remind_me my-3" (click)="remindMeLater()">بعدا یادآوری کن!</button>
        </div>
        <div class="col-6">
          <button class="btn btn-block android_notice_figure_out my-3" (click)="understand()">متوجه شدم</button>
        </div>
      </div>
    </div>
  </div>
</div>
